import styled from "styled-components";

export const BannerContainer = styled.img`
	@media only screen and (max-width: 770px) {
		max-width: 100%;
		/* display: none; */
	}
`;
